import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { theme } from 'src/styles/theme';

interface StyleProperties {
  backgroundColor: string;
  backgroundColorHover: string;
  color: string;
}

const getProperties = (active: boolean): StyleProperties => {
  if (active) {
    return {
      backgroundColor: theme.palette.common.blue50,
      backgroundColorHover: theme.palette.common.blue100,
      color: theme.palette.common.blue500,
    };
  }
  return {
    backgroundColor: theme.palette.common.gray200,
    backgroundColorHover: theme.palette.common.gray300,
    color: theme.palette.common.gray800,
  };
};

const useStyles = makeStyles<Theme, boolean>({
  arrow: {
    marginLeft: theme.spacing(1),
  },
  btn: btnActive => {
    const style = getProperties(btnActive);

    return {
      '&.Mui-selected': {
        ...style,
      },
      '&:hover': {
        backgroundColor: style.backgroundColorHover,
        cursor: 'default',
      },
      backgroundColor: style.backgroundColor,
      borderRadius: 100,
      color: style.color,
      cursor: 'default',
      fontFamily: theme.typography.overline.fontFamily,
      fontSize: theme.typography.overline.fontSize,
      fontWeight: 'normal',
      height: 28,
      lineHeight: theme.typography.overline.lineHeight,
      marginRight: theme.spacing(1.25),
      padding: `${theme.spacing(0.5)} ${theme.spacing(1.5)}`,
      textDecoration: 'none',
      textTransform: 'none',
    };
  },
  checkmark: {
    marginLeft: 18,
  },
  menu: {
    transform: `translateY(${theme.spacing(1)}px)`,
  },
  text: {
    color: theme.palette.common.gray800,
  },
});

export default useStyles;
